import { Button, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import AddIcon from "@mui/icons-material/Add";
import ManageTables from "./ManageTable";
import Stonomalies from "./Anomalies/STO_anomalies";

import { useEffect, useState } from "react";
import AddScopeModal from "./AddScopeModal";
import { useSelector } from "react-redux";
import MultiLoadingSnackbar from "../../../../MultiLoadingSnackbar";
import { selectUserData } from "../../../../../../../../features/userSlice";
import { CheckPermissions } from "../../../../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
interface SnackbarData {
  id: string;
  message: string;
  subMessage?: string;
}
const StoScope = () => {
  const response = useSelector(selectUserData);
  const [openDialog, setOpenDialog] = useState(false);
  const [snackbars, setSnackbars] = useState<SnackbarData[]>([]);
  const {
    newScopeLoading,
    editScopeLoading,
    campaignToScopeLoading,
    removeNegativeLoadingForBothLoading,
    removeNegativeLoadingCampaignLoading,
  } = useSelector((state: any) => state.searchTermOperation);

  const handleOpen = () => setOpenDialog(true);
  const handleClose = () => setOpenDialog(false);

  const hasCreateScopePermission = CheckPermissions(
    response?.data?.products?.paid_traffic,
    "plan_campaign_ppc",
    "create_st_account_management" // same for both(create and edit)
  );

  // loading snackbar for long api response
  useEffect(() => {
    const active = [];

    if (newScopeLoading) {
      active.push({
        id: "new-scope",
        message: "Creating scope and linking campaigns...",
        subMessage: "This may take several minutes, please wait.",
      });
    }
    if (editScopeLoading) {
      active.push({
        id: "edit-scope",
        message: "editing scope, linking and unlinking campaigns...",
        subMessage: "This may take several minutes, please wait.",
      });
    }

    if (campaignToScopeLoading) {
      active.push({
        id: "campaign-scope",
        message: "Linking campaigns to scopes...",
        subMessage: "This may take several minutes, please wait.",
      });
    }
    if (removeNegativeLoadingForBothLoading) {
      active.push({
        id: "remove-negative-both",
        message:
          "Removing negative keywords from both ad groups and campaigns...",
        subMessage: "This may take several minutes, please wait.",
      });
    }
    if (removeNegativeLoadingCampaignLoading) {
      active.push({
        id: "remove-negative-campaign",
        message: "Removing negative keywords from campaign...",
        subMessage: "This may take several minutes, please wait.",
      });
    }

    setSnackbars(active);
  }, [
    newScopeLoading,
    editScopeLoading,
    campaignToScopeLoading,
    removeNegativeLoadingForBothLoading,
    removeNegativeLoadingCampaignLoading,
  ]);

  return (
    <>
      {/* Loading top right for long api response */}
      <MultiLoadingSnackbar snackbars={snackbars} />
      <Box p={2}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack>
            <Typography variant="h5">Manage</Typography>
            <Typography variant="body2" gutterBottom color="text.secondary">
              Group Campaigns into Scopes or edit existing ones
            </Typography>
          </Stack>
          {hasCreateScopePermission ? (
            <Button
              data-tracker="497"
              onClick={handleOpen}
              disabled={
                newScopeLoading || editScopeLoading || campaignToScopeLoading
              }
              variant="outlined"
              color="secondary"
              endIcon={<AddIcon />}
            >
              Add new scope
            </Button>
          ) : (
            <Button
              data-tracker="497"
              variant="outlined"
              color="secondary"
              endIcon={<AddIcon />}
              disabled
            >
              Add new scope
            </Button>
          )}
        </Stack>
        <ManageTables />
        <Stonomalies />
        <AddScopeModal open={openDialog} onClose={handleClose} />
      </Box>
    </>
  );
};

export default StoScope;
